/** Config timing fields use millisecond suffixes; geometry, counts and phase fractions are untouched. */
export function scaleAnimationDurations<T>(config: T, multiplier: number): T {
    if (!Number.isFinite(multiplier) || multiplier <= 0) {
        throw new RangeError('Animation duration multiplier must be finite and positive.');
    }
    const scale = (value: unknown, key = ''): unknown => {
        if (typeof value === 'number' && /(?:Duration|Delay|Interval|Hold)Ms$/.test(key)) {
            const duration = value * multiplier;
            if (!Number.isFinite(duration)) {
                throw new RangeError(`Scaled animation timing "${key}" must be finite.`);
            }
            return duration;
        }
        if (Array.isArray(value)) return value.map((entry) => scale(entry));
        if (value !== null && typeof value === 'object') {
            return Object.fromEntries(Object.entries(value).map(([field, entry]) => [field, scale(entry, field)]));
        }
        return value;
    };
    // Only numeric timing values change; the input's config structure and value types are preserved.
    return scale(config) as T;
}
